import { render, staticRenderFns } from "./reaction-popup-menu.vue?vue&type=template&id=58f1dd03"
import script from "./reaction-popup-menu.vue?vue&type=script&lang=js"
export * from "./reaction-popup-menu.vue?vue&type=script&lang=js"
import style0 from "./reaction-popup-menu.vue?vue&type=style&index=0&id=58f1dd03&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports